exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".issue-list[data-v-d1d9a630]{background-color:#f9fafc;padding:10px}.issue-list p[data-v-d1d9a630]{margin:0}.issue-list .issue-date[data-v-d1d9a630]{font-size:10px;color:#909399}", "", {"version":3,"sources":["/workspace/src/views/issue/components/IssueLighter/index.vue"],"names":[],"mappings":"AACA,6BAA6B,yBAAyB,YAAY,CACjE,AACD,+BAA+B,QAAU,CACxC,AACD,yCAAyC,eAAe,aAAa,CACpE","file":"index.vue","sourcesContent":["\n.issue-list[data-v-d1d9a630]{background-color:#f9fafc;padding:10px\n}\n.issue-list p[data-v-d1d9a630]{margin:0px\n}\n.issue-list .issue-date[data-v-d1d9a630]{font-size:10px;color:#909399\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d1d9a630","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/issue/components/IssueLighter/index.vue
// module id = 2339
// module chunks = 5 138